"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8ArrayToSerializedParameter = exports.base64ToUint8Array = exports.uint8ArrayToBase64 = exports.isSerializedUint8Array = exports.isUint8Array = void 0;
const BASE64_MIME_TYPE = 'data:application/octet-stream;base64,';
function isUint8Array(data) {
    return ArrayBuffer.isView(data);
}
exports.isUint8Array = isUint8Array;
function isSerializedUint8Array(data) {
    const { type, value } = (data || {});
    return type === 'bytes' && typeof value === 'string';
}
exports.isSerializedUint8Array = isSerializedUint8Array;
function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
function uint8ArrayToBase64(bytes) {
    return convertBlobToBase64(new Blob([bytes]));
}
exports.uint8ArrayToBase64 = uint8ArrayToBase64;
function base64ToUint8Array(base64String) {
    return Uint8Array.from(atob(base64String.startsWith(BASE64_MIME_TYPE)
        ? base64String.substring(BASE64_MIME_TYPE.length)
        : base64String), c => c.charCodeAt(0));
}
exports.base64ToUint8Array = base64ToUint8Array;
function uint8ArrayToSerializedParameter(bytes) {
    return __awaiter(this, void 0, void 0, function* () {
        return {
            type: 'bytes',
            value: yield uint8ArrayToBase64(bytes),
        };
    });
}
exports.uint8ArrayToSerializedParameter = uint8ArrayToSerializedParameter;
